module.exports = __webpack_public_path__ + "img/succulent.7092c6dc.png";